import {escape as escapeHtml} from 'lodash-es';

export const insertBreakableName = (message: string, name: string): string =>
    message.replace('{0}', () => `<span class="text-break">${escapeHtml(name)}</span>`);
